import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

type ActionsProps = {
  onActionsDropdownClick: () => void;
  hasConversationReplyAccess: boolean;
  hasOrganizationMemberAccess: boolean;
  canMakeInternalCall: boolean;
  isOwnAgent: boolean;
  onCallClick: () => void;
  onEditClick: () => void;
};

export const Actions = ({
  onActionsDropdownClick,
  hasConversationReplyAccess,
  hasOrganizationMemberAccess,
  canMakeInternalCall,
  isOwnAgent,
  onCallClick,
  onEditClick,
}: ActionsProps) => (
  <div onClick={onActionsDropdownClick}>
    <DropdownButton
      data-dropdown-button={true}
      icon="dots-h"
      noArrow
      buttonProps={{ variant: 'tertiary' }}
      onToggle={(open) => open && ampli.teamAgentActionsMenuOpened()}
      dropdown={
        <ButtonList>
          {hasConversationReplyAccess && canMakeInternalCall && (
            <ButtonList.Item onClick={onCallClick} icon="phone">
              Call
            </ButtonList.Item>
          )}
          {(isOwnAgent || hasOrganizationMemberAccess) && (
            <ButtonList.Item onClick={onEditClick} icon="pen">
              Edit
            </ButtonList.Item>
          )}
        </ButtonList>
      }
    />
  </div>
);
